import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0be66a92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collection-detailed-search has-background-contents" }
const _hoisted_2 = { class: "collection-detailed-search-keyword level is-mobile" }
const _hoisted_3 = { class: "collection-detailed-search-body" }
const _hoisted_4 = { class: "collection-detailed-search-queries" }
const _hoisted_5 = { class: "collection-detailed-search-query span2" }
const _hoisted_6 = { class: "collection-detailed-search-query-name" }
const _hoisted_7 = { class: "collection-detailed-search-query-value" }
const _hoisted_8 = { class: "collection-detailed-search-query" }
const _hoisted_9 = { class: "collection-detailed-search-query-name" }
const _hoisted_10 = { class: "collection-detailed-search-query-value" }
const _hoisted_11 = { class: "collection-detailed-search-query" }
const _hoisted_12 = { class: "collection-detailed-search-query-name" }
const _hoisted_13 = { class: "collection-detailed-search-query-value" }
const _hoisted_14 = { class: "collection-detailed-search-query" }
const _hoisted_15 = { class: "collection-detailed-search-query-name" }
const _hoisted_16 = { class: "collection-detailed-search-query-value" }
const _hoisted_17 = { class: "collection-detailed-search-query" }
const _hoisted_18 = { class: "collection-detailed-search-query-name" }
const _hoisted_19 = { class: "collection-detailed-search-query-value" }
const _hoisted_20 = { class: "collection-detailed-search-query" }
const _hoisted_21 = { class: "collection-detailed-search-query-name" }
const _hoisted_22 = { class: "collection-detailed-search-query-value" }
const _hoisted_23 = { class: "collection-detailed-search-query" }
const _hoisted_24 = { class: "collection-detailed-search-query-name" }
const _hoisted_25 = { class: "collection-detailed-search-query-value" }
const _hoisted_26 = { class: "collection-detailed-search-action level is-mobile" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AppInput = _resolveComponent("AppInput")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_CheckboxList = _resolveComponent("CheckboxList")!
  const _component_CloserController = _resolveComponent("CloserController")!
  const _component_ModalSheetMobile = _resolveComponent("ModalSheetMobile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("form", {
      onSubmit: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
    }, [
      _createVNode(_component_ModalSheetMobile, {
        show: _ctx.showMobile,
        onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('close', false))),
        title: _ctx.$t('label.specifySearchConditions'),
        id: "collection-detailed-search-modal-sheet"
      }, {
        modal: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('form.accessRestrictions')), 1),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_CheckboxList, {
                    items: _ctx.accessRestrictions,
                    modelValue: _ctx.query.accessRestrictions,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query.accessRestrictions) = $event)),
                    id: "collection-detailed-search-access-restriction",
                    class: "collection-detailed-search-access-restriction"
                  }, null, 8, ["items", "modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('form.title')), 1),
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_AppInput, {
                    inputId: "collection-detailed-search-title",
                    modelValue: _ctx.query.title,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.title) = $event)),
                    label: "{{ $t('form.title') }}"
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t(`collectionForm.${_ctx.collectionId}.creator`)), 1),
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(_component_AppInput, {
                    inputId: "collection-detailed-search-creator",
                    modelValue: _ctx.query.creator,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.query.creator) = $event)),
                    label: _ctx.$t(`collectionForm.${_ctx.collectionId}.creator`)
                  }, null, 8, ["modelValue", "label"])
                ])
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([{ 'is-hidden-desktop': !_ctx.state.showAll }, "collection-detailed-search-queries"])
            }, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.$t(`collectionForm.${_ctx.collectionId}.series`)), 1),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_AppInput, {
                    inputId: "collection-detailed-search-series",
                    modelValue: _ctx.query.series,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query.series) = $event)),
                    label: _ctx.$t(`collectionForm.${_ctx.collectionId}.series`)
                  }, null, 8, ["modelValue", "label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t(`collectionForm.${_ctx.collectionId}.subject`)), 1),
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_AppInput, {
                    inputId: "collection-detailed-search-subject",
                    modelValue: _ctx.query.subject,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.query.subject) = $event)),
                    label: _ctx.$t(`collectionForm.${_ctx.collectionId}.subject`)
                  }, null, 8, ["modelValue", "label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t('form.callNumber')), 1),
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(_component_AppInput, {
                    inputId: "collection-detailed-search-callNumber",
                    modelValue: _ctx.query.callNumber,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.query.callNumber) = $event)),
                    label: _ctx.$t('form.callNumber')
                  }, null, 8, ["modelValue", "label"])
                ])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t(`collectionForm.${_ctx.collectionId}.identifier`)), 1),
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_AppInput, {
                    inputId: "collection-detailed-search-bibId",
                    modelValue: _ctx.query.identifier,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.query.identifier) = $event)),
                    label: _ctx.$t(`collectionForm.${_ctx.collectionId}.identifier`)
                  }, null, 8, ["modelValue", "label"])
                ])
              ])
            ], 2),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_CloserController, {
                modelValue: _ctx.state.showAll,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.showAll) = $event)),
                text: [_ctx.$t('parts.open'), _ctx.$t('parts.close')],
                class: "is-hidden-mobile"
              }, null, 8, ["modelValue", "text"]),
              _createVNode(_component_AppButton, {
                buttonId: "collection-detailed-search-clear-button",
                onClick: _withModifiers(_ctx.clearForm, ["prevent"]),
                onKeydown: _withKeys(_withModifiers(_ctx.clearForm, ["prevent"]), ["space","enter"]),
                styled: "is-none",
                class: "has-text-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('parts.clear')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "onKeydown"])
            ])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_AppInput, {
              "data-cy": "collection-detailed-search-keyword",
              modelValue: _ctx.query.keyword,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.query.keyword) = $event)),
              onSearch: _ctx.search,
              placeholder: _ctx.$t('message.itemKeywordSearchPlaceHolder'),
              styled: "is-none",
              class: "item-keyword-search",
              label: "keyword"
            }, null, 8, ["modelValue", "onSearch", "placeholder"]),
            _createVNode(_component_AppButton, {
              "data-cy": "collection-detailed-search-button",
              styled: "is-accent",
              type: "submit",
              label: _ctx.$t('parts.search')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('parts.search')), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ])
        ]),
        _: 1
      }, 8, ["show", "title"])
    ], 32)
  ]))
}